const namespace = 'api/'

// Getters
export const ERRORS = 'errors'
export const WARNINGS = 'warnings'
export const WARN_FIELDS = 'warnFields'
export const NOTICES = 'notices'
export const POSTED = 'posted'
export const POST_BUTTON = 'postButton'
export const BUSY_INDICATOR = 'busyIndicator'
export const BUSY_INTERVAL_ID = 'busyIntervalId'
export const BUSY_INTERVAL_TS = 'busyIntervalTs'
export const REQUEST_BUSY = 'requestBusy'

export const API_ERRORS = namespace + ERRORS
export const API_WARNINGS = namespace + WARNINGS
export const API_WARN_FIELDS = namespace + WARN_FIELDS
export const API_NOTICES = namespace + NOTICES
export const API_POSTED = namespace + POSTED
export const API_POST_BUTTON = namespace + POST_BUTTON
export const API_BUSY_INDICATOR = namespace + BUSY_INDICATOR
export const API_BUSY_INTERVAL_ID = namespace + BUSY_INTERVAL_ID
export const API_BUSY_INTERVAL_TS = namespace + BUSY_INTERVAL_TS
export const API_REQUEST_BUSY = namespace + REQUEST_BUSY

// Mutations
export const SET_ERRORS = 'setErrors'
export const SET_WARNINGS = 'setWarnings'
export const SET_WARN_FIELDS = 'setWarnFields'
export const REPLACE_WARN_FIELD = 'replaceWarnField'
export const SET_NOTICES = 'setNotices'
export const PURGE_RESULTS = 'purgeResults'
export const SET_POSTED = 'setPosted'
export const SET_POST_BUTTON = 'setPostButton'
export const SET_BUSY_INDICATOR = 'setBusyIndicator'
export const SET_BUSY_INTERVAL_ID = 'setBusyIntervalId'
export const SET_BUSY_INTERVAL_TS = 'setBusyIntervalTs'
export const SET_REQUEST_BUSY = 'setRequestBusy'

export const API_PURGE_RESULTS = namespace + PURGE_RESULTS
export const API_SET_ERRORS = namespace + SET_ERRORS
export const API_SET_WARNINGS = namespace + SET_WARNINGS
export const API_SET_WARN_FIELDS = namespace + SET_WARN_FIELDS
export const API_REPLACE_WARN_FIELD = namespace + REPLACE_WARN_FIELD
export const API_SET_NOTICES = namespace + SET_NOTICES
export const API_SET_POSTED = namespace + SET_POSTED
export const API_SET_POST_BUTTON = namespace + SET_POST_BUTTON
export const API_SET_BUSY_INDICATOR = namespace + SET_BUSY_INDICATOR
export const API_SET_BUSY_INTERVAL_ID = namespace + SET_BUSY_INTERVAL_ID
export const API_SET_BUSY_INTERVAL_TS = namespace + SET_BUSY_INTERVAL_TS
export const API_SET_REQUEST_BUSY = namespace + SET_REQUEST_BUSY



// WEBPACK FOOTER //
// ./src/store/api/postStatus.types.js